import { pageTypes } from "../constants/pageTypes";

export const getLeftNavSelection = (path) => {
    let splitPath = path?.split("/") || [];
    let finalPath = splitPath[1]?.toUpperCase();
    let penultimatePath = splitPath[2]?.toUpperCase();
    switch (finalPath || penultimatePath) {
        case pageTypes.DASHBOARD.toUpperCase(): { 
            return pageTypes.DASHBOARD;
         }
        case pageTypes.EVENTS.toUpperCase():
        case pageTypes.EVENT_INFO.toUpperCase():
        case pageTypes.INCIDENTS?.toUpperCase():    {
            return pageTypes.EVENTS;
        }
        case pageTypes.STATISTICS.toUpperCase():
        case pageTypes.STATDATASOURCE?.toUpperCase(): { 
            return pageTypes.STATISTICS;
         }
        case pageTypes.COMPANION_INFO.toUpperCase():
        case pageTypes.CAMERA_ONBOARDING.toUpperCase():
        case pageTypes.ROI_LISTING.toUpperCase():
        case pageTypes.CAMERA_INFO.toUpperCase():
        case pageTypes.DEVICES.toUpperCase():
        case pageTypes.CV_APP_SUB?.toUpperCase():    
        case pageTypes.CV_APPS_LICENSETYPE?.toUpperCase():
        case pageTypes.POLYGON?.toUpperCase():
        case pageTypes.MANUAL_CALIBRATION?.toUpperCase(): {
            return pageTypes.DEVICES;
        }
        case pageTypes.SETTINGS.toUpperCase():
        case pageTypes.USERSETTINGS.toUpperCase():
        case pageTypes.RULES.toUpperCase():
        case pageTypes.CREATE_RULE.toUpperCase():
        case pageTypes.CREATE_RULE_SUMMARY.toUpperCase():
        case pageTypes.USER_GROUPS.toUpperCase():
        case pageTypes.USER_GROUPS_DETAILS.toUpperCase():
        case pageTypes.USER_DETAILS.toUpperCase():
        case pageTypes.SITES.toUpperCase():
        case pageTypes.ADD_SITE.toUpperCase():
        case pageTypes.CAMPUS_DETAILS.toUpperCase():
        case pageTypes.EDIT_SITE.toUpperCase():
        case pageTypes.ROLES.toUpperCase():
        case pageTypes.CREATE_ROLE.toUpperCase():
        case pageTypes.EDIT_ROLE.toUpperCase(): 
        case pageTypes.SUPPORT.toUpperCase():
        case pageTypes.ALERTS.toUpperCase():
        case pageTypes.ALERT_DETAILS?.toUpperCase():
        case pageTypes.CREATE_ALERT?.toUpperCase():
        case pageTypes.LICENSES.toUpperCase():
        case pageTypes.LICENSE_DETAILS.toUpperCase():
        case pageTypes.ENROLLED_APPEARANCE.toUpperCase():
        case pageTypes.APPEARANCE_DEPLOYMENTS.toUpperCase():
        case pageTypes.CREATE_APPEARANCE.toUpperCase():
        case pageTypes.EDIT_APPEARANCE.toUpperCase(): {
            return pageTypes.SETTINGS;
        }
        case pageTypes.ASSISTANT.toUpperCase(): {
            return pageTypes.ASSISTANT;
        }
        case pageTypes.SEARCH.toUpperCase():
        case pageTypes.SEARCHRESULT.toUpperCase():
        case pageTypes.HISTORICAL_SEARCH.toUpperCase():{
            return pageTypes.SEARCH;
        }
        default: {
          return pageTypes.DASHBOARD;
        }
    }
}